import styled, { css } from "styled-components";

import CustomPagination from ".";

export const ActionRow = styled.div`
  align-items: end;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 0 0 2rem 0;
`;

export const CustomActionRow = styled(ActionRow)`
  flex-direction: row;
`;

export const Count = styled.div`
  border: 0.3rem solid ${({ theme }) => theme.colors.darkblue};
  border-radius: 0.5rem;
  padding: 0.4rem 0.8rem;
`;

export const TopPagination = styled(CustomPagination)`
  display: none;

  @media (${({ theme }) => theme.breakpoints.min800}) {
    display: flex;
  }
`;

export const BottomPagination = styled(CustomPagination)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2rem 0;
`;

export const narrowColumn = css`
  width: 15%;
`;
